module.exports = __webpack_public_path__ + "media/images/syntax_business_cube-c034031054b6db2ef889267c69fe94c3.gif";